/**
 * ReservationsShell — layout Sarabi Reservations (palette SARABI OS).
 * Senza sessione PIN valida → /reservations/login.
 */
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut } from "lucide-react";

export default function ReservationsShell() {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  useEffect(() => {
    if (!user) { nav("/reservations/login", { replace: true }); }
  }, [user, nav]);

  if (!user) { return null; }

  return (
    <div className="min-h-[100dvh] bg-sand-100 overflow-x-clip" data-testid="reservations-shell">
      <header className="sticky top-0 z-20 bg-sand-50/90 backdrop-blur-md border-b border-sand-200
                         pt-[env(safe-area-inset-top)]">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="leading-tight min-w-0">
            <div className="eyebrow text-[10px]">Sarabi Reservations</div>
            <div className="text-sm text-ink-900 truncate" data-testid="reservations-operator">
              {user.name || user.email}
            </div>
          </div>
          <button onClick={async () => { await logout(); nav("/reservations/login", { replace: true }); }}
                  data-testid="reservations-logout" aria-label="Esci"
                  className="h-10 px-3 rounded-full border border-sand-300 bg-white text-ink-700 text-xs
                             flex items-center gap-1.5 hover:bg-sand-50 active:scale-95 transition-transform">
            <LogOut className="w-4 h-4" /> Esci
          </button>
        </div>
      </header>
      <main className="pb-[env(safe-area-inset-bottom)]">
        <Outlet />
      </main>
    </div>
  );
}
